export default {
      id: "oc-dashboard-trend-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-trend",
      toString: function () {
        return this.url;
      }
    }